export type Word = { text: string; start: number; end: number };
/** Soniox can emit sub-word pieces, including zero-duration final syllables. */
export function transcriptionWords(raw: unknown): Word[] {
  if (!Array.isArray(raw) || raw.length > 100000)
    throw Error("자막 응답을 확인하지 못했습니다.");
  const tokens = raw
    .filter(
      (w): w is Word =>
        !!w &&
        typeof w.text === "string" &&
        w.text.length > 0 &&
        Number.isFinite(w.start) &&
        Number.isFinite(w.end) &&
        w.start >= 0,
    )
    .map((w) => ({ ...w, end: Math.max(w.start, w.end) }))
    .sort((a, b) => a.start - b.start);
  const words: Word[] = [];
  for (const token of tokens) {
    const last = words.at(-1);
    if (last && !/^\s/.test(token.text) && token.start - last.end < 0.8) {
      last.text += token.text;
      last.end = Math.max(last.end, token.end);
    } else words.push({ ...token });
  }
  return words;
}
